import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types';
import ButtonComponent from '@/Inputs/ButtonComponent';

const CouponComponentStyle = styled.div`
    margin: 22px 0 30px;
    width: 100%;
    max-width: 70%;
    .inner_point_container {
        padding: 20px 20px;
        width: 100%;
        box-shadow: 0 0 5px 0px #ddd;

        h3 {
            padding-bottom: 10px;
            margin-bottom: 10px;
        }
        .fillCount {
            display: grid;
            gap: 6px;

            input[type='text'] {
                border:1px solid rgb(196, 196, 196) !important;
                padding: 5px 10px 5px;
                font-size: 18px;
                width: 100%;
                max-width: 260px;
                min-height: 45px;
            }
        }
    }
    @media (max-width: 660px){
        max-width: 100%;
    }

`;

const CouponComponent = ({ couponCode, setCouponCode, _onCouponClick, couponErrorData }) => {

    return (
        <div className='main_couponSection shadow-[0px_0px_5px_0px_#ddd]'>
            <div className='inner_point_container p-[20px]'>
                <h3>Coupon Code</h3>

                <div className='fillCount mt-4'>
                    {(couponCode?.valid)
                        ?
                        <div className='flex flex-col gap-[10px]'>
                            <p className='w-full md:text-[28px] text-[21px] block'>{couponCode?.code}</p>
                            <ButtonComponent classes="bg-black text-[#fff]  font-normal  hover:bg-white hover:border-black hover:text-black" onClick={() => _onCouponClick('remove')}>Remove</ButtonComponent>
                        </div>
                        :
                        <>
                            <label htmlFor='coupan' style={{ marginBottom: '10px' }} className="block">Please enter your coupon code</label>

                            <div className='flex flex-col gap-[10px]'>
                                <input
                                    type="text"
                                    className='border border-[rgb(196, 196, 196)] p-[10px_10px_5px] text-[18px] min-h-[45px]'
                                    value={couponCode?.code}
                                    id="coupan"
                                    onChange={(e) => setCouponCode({ ...couponCode, code: e.target.value })}
                                />
                                <ButtonComponent
                                    classes={`!mb-0 bg-[#000000] hover:border-[#000000] hover:bg-white hover:text-[#000000]`}
                                    onClick={() => _onCouponClick('add')}>Apply</ButtonComponent>
                            </div>
                            <p className='mt-2'>Enter coupon code if you have one - not required</p>
                        </>
                    }
                </div>
                {couponErrorData && <p style={{ color: "red" }}>{couponErrorData}</p>}
            </div>
        </div>
    )
}
CouponComponent.propTypes = {
    couponCode: PropTypes.shape({
        valid: PropTypes.bool,
        code: PropTypes.string,
    }),
    setCouponCode: PropTypes.func,
    _onCouponClick: PropTypes.func,
    couponErrorData: PropTypes.string
}
export default CouponComponent;